import React, {useState} from "react";

import "./Accordion.css"


export const Accordion = (props) => {

    const[open, setOpen] = useState(false);

    return (
        <div className="accordion__section">
            <button className="accordion" onClick={() => setOpen(!open)}>
                <Plus/>
                <p  className="accordion__title">{props.heading}</p>
            </button>
            {open ? <div className="accordion__content" >
                        <div class="accordion__text">
                            <p>{props.body} </p>
                        </div>
                    </div> : <React.Fragment/> }
        </div>
    )
}


const Plus = () => {
    return(
        <svg
            class= {"accordion__icon"}
             height = {"10px"}
             width= {"10px"}
             xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 448 512">
            <path fill={"currentColor"}
                  d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"></path>
        </svg>
    );
}
